<template>
  <VMain>
    <VContainer>
      <div
        v-if="edits && showLoader"
        class="d-flex align-center"
        style="min-height: 80vh"
      >
        <v-progress-circular
          v-if="showLoader"
          class="mx-auto"
          indeterminate
          color="#72AFE7"
        ></v-progress-circular>
      </div>
      <div v-else>
        <VRow class="add__manage" v-if="!$vuetify.breakpoint.xs">
          <h1>
            <img src="@/assets/my-business.png" class="icon" />
            {{ "manage_profile_title" | localize }}
          </h1>
        </VRow>
        <VCard width="100%" v-else class="mb-5">
          <VRow class="px-5" justify="center">
            <VIcon v-if="!$vuetify.breakpoint.smAndDown" class="mt-7 mb-5">mdi-store</VIcon>
            <div v-else>
            <img
              width="42px"
              height="40px"
              src="@/assets/businesses/shopIcon.png"
              alt="shop"
              class="mt-6 mb-4"
              style="margin-right: 14px"
            />
          </div>
            <h2 class="mt-7 mb-5 ml-1">
              {{ "manage_profile_title" | localize }}
            </h2>
            <v-spacer></v-spacer>
            <VBtn
              v-if="!edits"
              color="#72AFE7"
              class="white--text mt-7 mb-5"
              width="25%"
              @click="createNewUser"
              >{{ "button_manage_profile_create" | localize }}</VBtn
            >
            <VBtn
              v-else
              color="#72AFE7"
              class="white--text mt-7 mb-5"
              width="40%"
              @click="updateManager"
              >{{ "add_business_update" | localize }}</VBtn
            >
          </VRow>
        </VCard>
        <!-- card list users -->
        <VCard evalution="5">
          <VCol xs="4" @keydown.enter.prevent="checkEdit">
            <VCol>
              <!-- <label v-if="!$vuetify.breakpoint.xs"
                >Email <span class="req">*</span></label
              > -->
              <VCol cols="12" md="8" lg="8" xl="8" sm="8">
                <VTextField
                  dense
                  outlined
                  type="email"
                  placeholder="Type here..."
                  v-model="owner.email"
                  :error-messages="
                    emailError.length ? emailError : emailErrors | localize
                  "
                  @blur="$v.owner.email.$touch()"
                  :hide-details="!emailError.length && !emailErrors.length"
                >
                  <template v-slot:label>
                    Email <span class="req">*</span>
                  </template>
                </VTextField>
              </VCol>
              <VRow no-gutters v-if="!$vuetify.breakpoint.xs">
                <VCol cols="12" md="4" lg="4" xl="4" sm="8">
                  <!-- <label v-if="!$vuetify.breakpoint.xs"
                    >{{ "label_login_first_name" | localize }}
                    {{ "label_first_name" | localize }}
                    <span class="req">*</span></label
                  > -->
                  <VCol>
                    <VTextField
                      class="mr-sm-2"
                      dense
                      placeholder="Type here..."
                      outlined
                      v-model="owner.first_name"
                      :error-messages="firstNameError | localize"
                      @blur="$v.owner.first_name.$touch()"
                      :hide-details="!firstNameError.length"
                    >
                      <template v-slot:label>
                        {{ "label_login_first_name" | localize }}
                        {{ "label_first_name" | localize }}
                        <span class="req">*</span>
                      </template>
                    </VTextField>
                  </VCol>
                </VCol>
                <VCol cols="12" md="4" lg="4" xl="4" sm="8">
                  <!-- <label v-if="!$vuetify.breakpoint.xs"
                    >{{ "label_login_last_name" | localize }}
                    {{ "label_last_name" | localize }}
                    <span class="req">*</span></label
                  > -->
                  <VCol>
                    <VTextField
                      dense
                      outlined
                      v-model="owner.last_name"
                      :error-messages="lastNameError | localize"
                      @blur="$v.owner.last_name.$touch()"
                      :hide-details="!lastNameError.length"
                    >
                      <template v-slot:label>
                        {{ "label_login_last_name" | localize }}
                        {{ "label_last_name" | localize }}
                        <span class="req">*</span>
                      </template>
                    </VTextField>
                  </VCol>
                </VCol>
              </VRow>
              <VCol v-else>
                <VTextField
                  dense
                  placeholder="Type here..."
                  outlined
                  v-model="owner.first_name"
                  :error-messages="firstNameError | localize"
                  @blur="$v.owner.first_name.$touch()"
                  :hide-details="!firstNameError.length"
                >
                  <template v-slot:label v-if="$vuetify.breakpoint.xs">
                    {{ "label_login_first_name" | localize }}
                    {{ "label_first_name" | localize }}
                    <span class="req">*</span>
                  </template>
                </VTextField>
                <VTextField
                  class="mt-6"
                  dense
                  :label="'label_login_last_name' | localize"
                  placeholder="Type here..."
                  outlined
                  v-model="owner.last_name"
                  :error-messages="lastNameError | localize"
                  @blur="$v.owner.last_name.$touch()"
                  :hide-details="!lastNameError.length"
                >
                  <template v-slot:label>
                    {{ "label_login_last_name" | localize }}
                    {{ "label_last_name" | localize }}
                    <span class="req">*</span>
                  </template>
                </VTextField>
              </VCol>
              <!-- <label v-if="!$vuetify.breakpoint.xs"
                >{{ "label_login_phone_number" | localize }}
                {{ "label_phone_number" | localize }}
                <span class="req">*</span></label
              > -->
              <VRow class="my-0">
                <VCol cols="12" md="2" lg="2" xl="2" sm="8">
                  <VTextField
                    :class="$vuetify.breakpoint.xs ? 'px-3' : 'px-2 ml-1'"
                    v-model="owner.phone_code"
                    :label="$vuetify.breakpoint.xs ? 'Cod' : ''"
                    dense
                    outlined
                    maxlength="5"
                    return-masked-value
                    v-mask="'+####'"
                    disabled
                    :hide-details="!codError.length"
                    :error-messages="codError"
                    @blur="$v.owner.phone_code.$touch()"
                  >
                  </VTextField>
                </VCol>
                <VCol cols="12" md="6" lg="6" xl="6" sm="8">
                  <VTextField
                    :class="$vuetify.breakpoint.xs ? 'px-3' : 'px-1'"
                    dense
                    outlined
                    v-model="owner.phone_number"
                    v-mask="'(##) ####-####'"
                    :append-icon="
                      !numberError.length && owner.phone_number
                        ? icons.mdiCheck
                        : '' || numberError.length
                        ? icons.mdiAlertCircleOutline
                        : ' '
                    "
                    :color="numberError ? 'success' : 'error'"
                    :hide-details="!numberError.length"
                    :error-messages="numberError | localize"
                    @blur="$v.owner.phone_number.$touch()"
                  >
                    <template v-slot:label>
                      {{ "label_login_phone_number" | localize }}
                      {{ "label_phone_number" | localize }}
                      <span class="req">*</span>
                    </template>
                  </VTextField>
                </VCol>
                <!-- <VCol cols="12" md="2" lg="2" xl="2" sm="8">
                  <VTextField
                    placeholder="Type here..."
                    :class="$vuetify.breakpoint.xs ? 'px-3' : 'px-1'"
                    dense
                    label="Ext"
                    outlined
                    v-model="owner.ext"
                  />
                </VCol> -->
              </VRow>
              <!-- <label v-if="!$vuetify.breakpoint.xs"
                >{{ "label_login_company" | localize }}
                {{ "label_company" | localize }}
                <span class="req">*</span></label
              > -->
              <VCol cols="12" md="8" lg="8" xl="8" sm="8">
                <VTextField
                  placeholder="Type here..."
                  dense
                  outlined
                  v-model="owner.company_name"
                  :error-messages="companyNameError | localize"
                  @blur="$v.owner.company_name.$touch()"
                  :hide-details="!companyNameError.length"
                >
                  <template v-slot:label>
                    {{ "label_login_company" | localize }}
                    {{ "label_company" | localize }} <span class="req">*</span>
                  </template>
                </VTextField>
              </VCol>
              <VRow no-gutters v-if="!$vuetify.breakpoint.xs">
                <VCol cols="12" md="4" lg="4" xl="4" sm="8">
                  <!-- <label v-if="!$vuetify.breakpoint.xs"
                    >{{ "label_login_city" | localize }}
                    {{ "label_city" | localize }}
                    <span class="req">*</span></label
                  > -->
                  <VCol>
                    <VTextField
                      placeholder="Type here..."
                      dense
                      outlined
                      v-model="owner.city"
                      :error-messages="cityError | localize"
                      @blur="$v.owner.city.$touch()"
                      :hide-details="!cityError.length"
                    >
                      <template v-slot:label>
                        {{ "label_login_city" | localize }}
                        {{ "label_city" | localize }} <span class="req">*</span>
                      </template>
                    </VTextField>
                  </VCol>
                </VCol>
                <VCol cols="12" md="4" lg="4" xl="4" sm="8">
                  <!-- <label v-if="!$vuetify.breakpoint.xs"
                    >{{ "label_login_country" | localize }}
                    {{ "label_country" | localize }}
                    <span class="req">*</span></label
                  > -->
                  <VCol>
                    <v-autocomplete
                      dense
                      outlined
                      v-model="owner.country"
                      :hide-details="!countryError.length"
                      :error-messages="countryError | localize"
                      @blur="$v.owner.country.$touch()"
                      :menu-props="{ bottom: true, offsetY: true }"
                      :items="Object.values(countryList)"
                      :item-value="'id'"
                      :item-text="'name'"
                      placeholder="Select"
                    >
                      <template v-slot:label>
                        {{ "label_login_country" | localize }}
                        {{ "label_country" | localize
                        }}<span class="req"> *</span>
                      </template>
                    </v-autocomplete>
                  </VCol>
                </VCol>
              </VRow>
              <VCol v-else>
                <VTextField
                  dense
                  placeholder="Type here..."
                  outlined
                  v-model="owner.city"
                  :error-messages="cityError | localize"
                  @blur="$v.owner.city.$touch()"
                  :hide-details="!cityError.length"
                >
                  <template v-slot:label v-if="$vuetify.breakpoint.xs">
                    {{ "label_login_city" | localize }}
                    {{ "label_city" | localize }} <span class="req">*</span>
                  </template>
                </VTextField>
                <v-autocomplete
                  class="mt-6"
                  dense
                  outlined
                  placeholder="Select"
                  v-model="owner.country"
                  :hide-details="!countryError.length"
                  :error-messages="countryError | localize"
                  @blur="$v.owner.country.$touch()"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="Object.values(countryList)"
                  :item-value="'id'"
                  :item-text="'name'"
                >
                  <template v-slot:label v-if="$vuetify.breakpoint.xs">
                    {{ "label_login_country" | localize }}
                    {{ "label_country" | localize }} <span class="req"> *</span>
                  </template>
                </v-autocomplete>
              </VCol>
              <h2 class="h__security">
                {{ "manage_profile_manage_roles" | localize }}
              </h2>
              <VDivider class="divider" />
              <VRow no-gutters align="center" v-if="!$vuetify.breakpoint.xs">
                <VCol cols="12" md="4" lg="4" xl="4" sm="8">
                  <!-- <label v-if="!$vuetify.breakpoint.xs"
                    >{{ "manage_profile_manage_roles" | localize }}
                    <span class="req">*</span></label
                  > -->
                  <VCol>
                    <v-autocomplete
                      dense
                      placeholder="Select"
                      :items="Object.values(business)"
                      :item-value="'uid'"
                      :item-text="!isSocial ? 'shop_name' : 'name'"
                      outlined
                      v-model="owner.shop_uid"
                      :error-messages="businessError | localize"
                      @blur="$v.owner.shop_uid.$touch()"
                      :hide-details="!businessError.length"
                    >
                      <template v-slot:label>
                        {{ "manage_profile_manage_roles" | localize }}
                        <span class="req">*</span>
                      </template>
                    </v-autocomplete>
                  </VCol>
                </VCol>
                <VCol cols="12" md="4" lg="4" xl="4" sm="8">
                  <!-- <label v-if="!$vuetify.breakpoint.xs">
                    <VRow no-gutters align="center">
                      {{ "label_mange_profile_role" | localize }}
                      <span class="ml-1 req">*</span>
                      <v-tooltip top max-width="400px">
                        <template v-slot:activator="{ on, attrs }">
                          <VIcon class="ml-2" v-on="on" v-bind="attrs" small
                            >mdi-information</VIcon
                          >
                        </template>

                        <span>
                          {{ "explain_manger_label" | localize }}<br />
                          {{ "explain_sales_label" | localize }}<br />
                          {{ "explain_viewer_label" | localize }}<br />
                        </span>
                      </v-tooltip>
                    </VRow>
                  </label> -->
                  <VCol>
                    <VRow>
                      <v-autocomplete
                        dense
                        placeholder="Select"
                        v-model="owner.role_id"
                        :items="Object.values(roles)"
                        :item-value="'id'"
                        :item-text="'name'"
                        :menu-props="{ bottom: true, offsetY: true }"
                        outlined
                        :error-messages="levelError | localize"
                        @blur="$v.owner.role_id.$touch()"
                        :hide-details="!levelError.length"
                      >
                        <template v-slot:label v-if="$vuetify.breakpoint.xs">
                          {{ "label_mange_profile_role" | localize }}
                          <span class="req">*</span>
                        </template>
                      </v-autocomplete>
                      <v-tooltip top max-width="400px">
                        <template v-slot:activator="{ on, attrs }">
                          <VIcon class="ml-2" v-on="on" v-bind="attrs"
                            >mdi-information</VIcon
                          >
                        </template>

                        <span>
                          {{ "explain_manger_label" | localize }}<br />
                          {{ "explain_sales_label" | localize }}<br />
                          {{ "explain_viewer_label" | localize }}<br />
                        </span>
                      </v-tooltip>
                    </VRow>
                  </VCol>
                </VCol>
              </VRow>
              <VCol v-else>
                <v-autocomplete
                  dense
                  placeholder="Select"
                  :items="Object.values(business)"
                  :item-value="'uid'"
                  :item-text="!isSocial ? 'shop_name' : 'name'"
                  outlined
                  v-model="owner.shop_uid"
                  :error-messages="businessError | localize"
                  @blur="$v.owner.shop_uid.$touch()"
                  :hide-details="!businessError.length"
                >
                  <template v-slot:label v-if="$vuetify.breakpoint.xs">
                    {{ "manage_profile_manage_roles" | localize }}
                    <span class="req">*</span>
                  </template>
                </v-autocomplete>
                <VRow no-gutters align="center" id="tooltip_id">
                  <v-autocomplete
                    class="mt-6"
                    dense
                    style="width: 80%"
                    v-model="owner.role_id"
                    :items="Object.values(roles)"
                    :item-value="'id'"
                    :item-text="'name'"
                    :menu-props="{ bottom: true, offsetY: true }"
                    outlined
                    :error-messages="levelError | localize"
                    @blur="$v.owner.role_id.$touch()"
                    :hide-details="!levelError.length"
                  >
                    <template v-slot:label v-if="$vuetify.breakpoint.xs">
                      {{ "label_mange_profile_role" | localize }}
                      <span class="req">*</span>
                    </template>
                  </v-autocomplete>
                  <v-tooltip
                    max-width="350"
                    min-width="280px"
                    nudge-right="-380"
                    top
                    left
                    :open-on-click="true"
                    :open-on-hover="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <VIcon class="ml-2 mt-5" v-on="on" v-bind="attrs"
                        >mdi-information</VIcon
                      >
                    </template>

                    <span>
                      {{ "explain_manger_label" | localize }}<br />
                      {{ "explain_sales_label" | localize }}<br />
                      {{ "explain_viewer_label" | localize }}<br />
                    </span>
                  </v-tooltip>
                </VRow>
              </VCol>
              <VRow
                v-if="$vuetify.breakpoint.xs && edits"
                justify="center"
                class="mt-3"
              >
                <VBtn
                  outlined
                  color="#72AFE7"
                  width="40%"
                  class="black--text"
                  style="border: 1px solid #72afe7"
                  @click="$router.push({ name: 'manage_users' })"
                  dark
                  >{{ "promotion_cancel" | localize }}</VBtn
                >
              </VRow>
              <VCol cols="12" md="8" lg="8" xl="8" sm="8">
                <VRow
                  class="mt-3"
                  :justify="!edits ? 'center' : 'start'"
                  v-if="!$vuetify.breakpoint.xs"
                >
                  <VBtn
                    v-if="!edits"
                    color="#72AFE7"
                    class="font-weight-bold"
                    @click="createNewUser"
                    dark
                    >{{ "button_manage_profile_create" | localize }}</VBtn
                  >
                  <div v-else>
                    <VRow class="ml-2 mb-4">
                      <VBtn
                        color="#72AFE7"
                        class="font-weight-bold"
                        @click="$router.push({ name: 'manage_users' })"
                        dark
                        >{{ "button_manage_profile_back" | localize }}</VBtn
                      >
                      <VBtn
                        color="#72AFE7"
                        class="font-weight-bold ml-5"
                        @click="updateManager"
                        dark
                        >{{ "add_business_update" | localize }}</VBtn
                      >
                    </VRow>
                  </div>
                </VRow>
              </VCol>
            </VCol>
          </VCol>
        </VCard>
      </div>
    </VContainer>
  </VMain>
</template>

<script>
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
import { mdiCheck, mdiAlertCircleOutline } from "@mdi/js";
import CountriesService from "@/requests/List/CountriesService";
import ManagerService from "@/requests/Manager/ManagerService";
import RolesService from "@/requests/List/RolesService";
import BusinessService from "@/requests/Business/BusinessService";
import requestFormData from "@/requests/requestFormData";
import SocialService from "@/requests/Socials/SocialService";
export default {
  mixins: [validationMixin],
  data: () => ({
    showMenu: false,
    owner: [],
    roles: [],
    business: [],
    countryList: [],
    cod: [],
    code: [],
    isSocial: false,
    emailErrors: [],
    icons: {
      mdiCheck,
      mdiAlertCircleOutline,
    },
    showLoader: true,
  }),
  props: {
    edit: {
      require: false,
    },
    uid: {
      require: false,
    },
  },
  validations: {
    owner: {
      email: {
        required,
        email,
      },
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      phone_code: {
        required,
      },
      phone_number: {
        required,
        minLength: minLength(14),
      },
      company_name: {
        required,
      },
      city: {
        required,
      },
      country: {
        required,
      },
      role_id: {
        required,
      },
      shop_uid: {
        required,
      },
    },
  },
  mounted() {
    this.getCountries();
    this.getRoles();
    this.owner.phone_code = this.loggedUser.phoneCode;
    if (this.edits) {
      this.getManager();
    }
    if (process.env.VUE_APP_TYPE === "Social") {
      this.isSocial = true;
    }
    if (this.isSocial) {
      this.getSocial();
    } else {
      this.getBusiness();
    }
    this.owner.type = process.env.VUE_APP_TYPE;
  },
  methods: {
    async createNewUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          const validCode = ("" + this.owner.phone_code).replace(/\D/g, "");
          const validPhone = ("" + this.owner.phone_number).replace(/\D/g, "");
          let data = {
            type: process.env.VUE_APP_TYPE,
            first_name: this.owner.first_name,
            last_name: this.owner.last_name,
            email: this.owner.email,
            company_name: this.owner.company_name,
            country: this.owner.country,
            city: this.owner.city,
            phone_code: validCode,
            phone_number: validPhone,
            activation_url:
              `${location.protocol}` +
              "//" +
              `${location.host}` +
              "/activate_manager/",
            business: [
              {
                uid: this.owner.shop_uid,
                role_id: parseInt(this.owner.role_id),
              },
            ],
          };
          if (this.owner.ext) {
            data.ext = this.owner.ext;
          }
          let form = requestFormData.jsonToFormData(data);
          let response = await ManagerService.createNewManager(form);
          if (response.error !== null && response.error.email) {
            this.emailErrors = [];
            this.emailErrors.push("validation_email_unique");
          } else {
            this.owner = [];
            this.$router.push({ name: "manage_users" });
          }
        } catch (e) {
          this.showLoader = false;
        }
      }
    },
    async updateManager() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          const validPhone = ("" + this.owner.phone_number).replace(/\D/g, "");
          let data = {
            type: process.env.VUE_APP_TYPE,
            first_name: this.owner.first_name,
            last_name: this.owner.last_name,
            email: this.owner.email,
            company_name: this.owner.company_name,
            country: this.owner.country,
            city: this.owner.city,
            phone_code: this.owner.phone_code,
            phone_number: validPhone,
            business: [
              {
                uid: this.owner.shop_uid,
                role_id: parseInt(this.owner.role_id),
              },
            ],
          };
          if (this.owner.ext) {
            data.ext = this.owner.ext;
          }
          let form = requestFormData.jsonToFormData(data);
          let response = await ManagerService.changeManager(
            this.$route.params.uid,
            form
          );
          if (response.error !== null && response.error.email) {
            this.emailErrors = [];
            this.emailErrors.push("validation_email_unique");
          } else {
            this.$emit("edit");
            this.$router.push({ name: "manage_users" });
          }
        } catch (e) {
          this.showLoader = false;
        }
      }
    },
    async getManager() {
      try {
        let response = await ManagerService.getManager(this.$route.params.uid);
        this.owner = response.result;
        console.log(this.owner);
        if (process.env.VUE_APP_TYPE === "Business") {
          response.result.business.forEach(
            (b) => (
              (this.owner.shop_uid = b.shop_uid),
              (this.owner.role_id = b.role_id)
            )
          );
        }
        {
          response.result.organisations.forEach(
            (b) => (
              (this.owner.shop_uid = b.social_uid),
              (this.owner.role_id = b.role_id)
            )
          );
        }
        this.showLoader = false;
      } catch (e) {
        this.showLoader = false;
      }
    },
    async getCountries() {
      try {
        let response = await CountriesService.getCountries(this.user.locale);
        this.countryList = response.result;
      } catch (e) {
        this.showLoader = false;
      }
    },
    async getRoles() {
      try {
        let response = await RolesService.getRoles();
        if (process.env.VUE_APP_TYPE === "Social") {
          this.roles.push(response.result[0]);
          this.roles.push(response.result[2]);
        } else {
          this.roles = response.result;
        }
      } catch (e) {
        this.showLoader = false;
      }
    },
    async getBusiness() {
      try {
        let response = await BusinessService.getListBusiness();
        this.business = response.result;
      } catch (e) {
        this.showLoader = false;
      }
    },
    async getSocial() {
      try {
        let response = await SocialService.getAllSocial();
        this.business = response.result;
        console.log(response);
      } catch (e) {
        this.showLoader = false;
      }
    },
    checkEdit() {
      if (this.edits) {
        this.updateManager();
      } else {
        this.createNewUser();
      }
    },
  },
  watch: {
    loggedUser: {
      deep: true,
      handler() {
        this.getRoles();
      },
    },
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["loggedUser"]),
    edits: {
      get() {
        return this.edit;
      },
    },
    uId: {
      get() {
        return this.uid;
      },
    },
    emailError() {
      const errors = [];
      if (!this.$v.owner.email.$dirty) {
        return errors;
      }
      !this.$v.owner.email.required && errors.push("validation_email_required");
      if (!this.$v.owner.email.email) {
        errors.push("validation_email_incorrect");
        return errors;
      }
      return errors;
    },
    firstNameError() {
      const errors = [];
      if (!this.$v.owner.first_name.$dirty) {
        return errors;
      }
      !this.$v.owner.first_name.required &&
        errors.push("validation_first_name_required");
      return errors;
    },
    lastNameError() {
      const errors = [];
      if (!this.$v.owner.last_name.$dirty) {
        return errors;
      }
      !this.$v.owner.last_name.required &&
        errors.push("validation_last_name_required");
      return errors;
    },
    codError() {
      const errors = [];
      if (!this.$v.owner.phone_code.$dirty) {
        return errors;
      }
      !this.$v.owner.phone_code.required && errors.push("Cod is required");
      return errors;
    },
    numberError() {
      const errors = [];
      if (!this.$v.owner.phone_number.$dirty) {
        return errors;
      }
      !this.$v.owner.phone_number.minLength && errors.push(" ");
      !this.$v.owner.phone_number.required &&
        errors.push("validation_phone_number_required");

      return errors;
    },
    companyNameError() {
      const errors = [];
      if (!this.$v.owner.company_name.$dirty) {
        return errors;
      }
      !this.$v.owner.company_name.required &&
        errors.push("validation_company_required");
      return errors;
    },
    cityError() {
      const errors = [];
      if (!this.$v.owner.city.$dirty) {
        return errors;
      }
      !this.$v.owner.city.required && errors.push("validation_city_required");
      return errors;
    },
    countryError() {
      const errors = [];
      if (!this.$v.owner.country.$dirty) {
        return errors;
      }
      !this.$v.owner.country.required &&
        errors.push("validation_country_required");
      return errors;
    },
    businessError() {
      const errors = [];
      if (!this.$v.owner.shop_uid.$dirty) {
        return errors;
      }
      !this.$v.owner.shop_uid.required &&
        errors.push("validation_add_manager_business_ID_required");

      return errors;
    },
    levelError() {
      const errors = [];
      if (!this.$v.owner.role_id.$dirty) {
        return errors;
      }
      !this.$v.owner.role_id.required &&
        errors.push("validation_add_manager_role_ID_required");

      return errors;
    } /**/,
  },
};
</script>

<style scoped>
.add__manage {
  margin-top: 60px;
  margin-bottom: 20px;
}
.h__security {
  margin-bottom: 10px;
}
.divider {
  margin-bottom: 10px;
}
.req {
  color: red;
}
</style>